export const redirectPage = (element, afterLoginPage = '/home', initialPage = '/') => {
  window.localStorage.removeItem('@redirect')
  if(!element){
    window.localStorage.setItem('@redirect', JSON.stringify(afterLoginPage))
    window.location.href = initialPage
  }
}